<template>
    <aside-panel
        class="user-mailbox-aside"
        ref="modal">
        <template #actions>
            <action-button
                title="Save"
                :icon="$icons.save"
                @action="save">
            </action-button>

        </template>
        <waiter ref="waiter">
            <ValidationObserver ref="observer" v-slot="{invalid}">
                <div class="user-mailbox-aside__body">
                    <b-card class="my-3">
                        <x-form-fieldset
                            title="Mailbox (POP/IMAP)">

                            <x-form-switch
                                title="Enable"
                                :value="mailbox.is_popbox"
                                @change="onChangeMailbox">
                            </x-form-switch>
                            <template v-if="mailbox.is_popbox">
                                <ValidationProvider
                                    vid="emailPassProvider"
                                    ref="emailPassProvider"
                                    rules="min:8"
                                    name="password">
                                    <x-form-password
                                        slot-scope="{ valid, errors }"
                                        :valid="valid"
                                        :errors="errors"
                                        title="Password"
                                        db-field=""
                                        v-model="mailbox.password"
                                    >
                                    </x-form-password>
                                </ValidationProvider>
                                <x-form-group>
                                    <action-link
                                        class="d-inline-flex"
                                        title="Open mailbox"
                                        :disabled="isNewMailbox"
                                        target="_blank"
                                        :icon="$icons.external_link"
                                        :href="'/mail/?_user='+u_email">
                                        <span class="ml-2" style="margin-top: 3px">View in webmail-client</span>
                                    </action-link>
                                </x-form-group>
                            </template>


                        </x-form-fieldset>
                        <hr>
                        <x-form-fieldset
                            title="Forward and Maillist">

                            <x-form-group
                                title="Forward to">
                                <forward-to
                                    v-model="mailbox.mailboxdest"
                                    :aliases.sync="aliases">
                                </forward-to>
                            </x-form-group>
                            <x-form-switch
                                title="Send mail to usergroup"
                                v-model="mailbox.is_maillisting_dest"
                                values="boolean">
                            </x-form-switch>
                            <div v-show="mailbox.is_maillisting_dest">
                                <x-form-group>
                                    <x-form-fieldset title="Usergroups">
                                        <x-form-group
                                            label-cols-sm="4"
                                            label-cols-lg="3"
                                            title="Members usergroup">
                                            <ValidationProvider
                                                vid="mUsergroupProvider"
                                                ref="mUsergroupProvider"
                                                name="usergroup"
                                            >
                                                <div slot-scope="{ valid, errors }">
                                                    <select-usergroup
                                                        id="maillisting_usergroup"
                                                        v-model="mailbox.maillisting_usergroup">
                                                    </select-usergroup>
                                                    <div class="invalid-feedback" style="display: block"
                                                         v-if="errors.length > 0">
                                                        {{ errors[0] }}
                                                    </div>
                                                </div>
                                            </ValidationProvider>
                                        </x-form-group>
                                        <x-form-group
                                            label-cols-sm="4"
                                            label-cols-lg="3"
                                            title="Moderators usergroup">
                                            <select-usergroup id="maillisting_moderatorgroup"
                                                              v-model="mailbox.maillisting_moderatorgroup"></select-usergroup>
                                        </x-form-group>
                                    </x-form-fieldset>
                                </x-form-group>
                            </div>
                        </x-form-fieldset>
                    </b-card>
                </div>
            </ValidationObserver>
        </waiter>
    </aside-panel>
</template>

<script>

import AsidePanel from '@/components/containers/components/AsidePanel'
import XMultiselect from '@/components/XMultiselect'

import users from '@/services/api/users'
import ForwardTo from '@/views/users/parties/ForwardTo'

export default {
    name: 'UserMailboxAside',
    components: {ForwardTo, AsidePanel, XMultiselect},
    props: {
        u_id: {
            required: true
        },
        u_email: {
            required: true
        }
    },
    data() {
        return {
            isNewMailbox: true,
            mailbox: {
                password: ''
            },
            aliases: [],
        }
    },
    methods: {

        async show() {
            this.$refs.modal.show()
            this.isNewMailbox = true
            await this.load()
        },

        async onChangeMailbox(value) {
            if (value === 1) {
                this.mailbox.is_popbox = true
                return
            }
            if (this.isNewMailbox) {
                this.mailbox.is_popbox = false
                return
            }

            let response = await this.$dialogs.confirmDelete({
                okTitle: 'DELETE',
                message: 'Are you sure you want to delete the mailbox for this user?'
            })
            if (response.trigger !== 'ok') {
                this.mailbox.is_popbox = false
                this.$nextTick(() => {
                    this.mailbox.is_popbox = true
                })
            }
            this.mailbox.is_popbox = false
        },
        async load() {
            let data = await this.$refs.waiter.wait(users.getUserMailbox({u_id: this.u_id}))
            if (data.aliases) {
                this.aliases = data.aliases
            }
            if (data && data.mailbox) {
                this.mailbox = data.mailbox
                this.mailbox.password = ''
            }
            if (this.mailbox.is_popbox) {
                this.isNewMailbox = false
            }
        },
        async save() {
            let isValid = await this.$refs.observer.validate()
            if (!isValid) return

            if (this.mailbox.is_popbox && this.isNewMailbox && this.mailbox.password.length === 0) {
                this.$refs.observer.setErrors({
                    emailPassProvider: ['Password filed is required for create mailbox.'],
                });
                return
            }

            if (this.mailbox['is_maillisting_dest'] && !this.mailbox['maillisting_usergroup']) {
                this.$refs.observer.setErrors({
                    mUsergroupProvider: ['Usergroup is required.'],
                });
                return
            }
            await this.$refs.waiter.wait(
                users.saveUserMailbox({u_id: this.u_id, mailbox: this.mailbox})
            )
            this.isNewMailbox = false
        },
    }
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/vue-component";


</style>
